<div class="flex flex-row flex-wrap w-1/3">
  <div *ngIf="showAllButton" (click)="clearFilter($event)" class="flex flex-row items-center item btn-font-rounded mb-16">
    <mat-icon *ngIf="selectedCount === 0" name="done" class="icons mr-6"></mat-icon>
    {{ 'FILTER.ALL' | transloco: {totalCount: totalCount} | uppercase }}
  </div>

  <div *ngFor="let filterItem of filterItems"
       (click)="toggleSelected(filterItem, $event)"
       [ngClass]="{'selected': filterItem.selected}"
       class="flex items-center item btn-font-rounded mb-16">
    <div>{{ filterItem.label | uppercase }}</div>
  </div>

  <div *ngIf="showClearButton" [ngClass]="{'disabled': selectedCount === 0}" (click)="clearFilter($event)"
       class="flex flex-row items-center item btn-font-rounded mb-16">
    <mat-icon svgIcon="refresh" class="icons mr-6"></mat-icon>
    {{ 'FILTER.CLEAR_FILTERS' | transloco | uppercase }}
  </div>
</div>
